import type { CrmCustomerRecordDeliveredArea } from '@features/crm-customer-record-context';

export const crmCustomerRecordAreas = [
  {
    id: 'overview',
    labelKey: 'crm.customerProfile.navigation.overview',
    labelFallback: 'Overview',
    availabilityKey: null,
    availabilityFallback: null,
    deliveryState: 'delivered',
    route: '/$locale/crm/user-profiles/$userProfileId',
    ownerTask: 'Phase 45.3f',
  },
  {
    id: 'membership',
    labelKey: 'crm.customerProfile.navigation.membership',
    labelFallback: 'Membership',
    availabilityKey: null,
    availabilityFallback: null,
    deliveryState: 'delivered',
    route: '/$locale/crm/user-profiles/$userProfileId/membership',
    ownerTask: 'Phase 45.4',
  },
  {
    id: 'learning',
    labelKey: 'crm.customerProfile.navigation.learning',
    labelFallback: 'Learning',
    availabilityKey: null,
    availabilityFallback: null,
    deliveryState: 'delivered',
    route: '/$locale/crm/user-profiles/$userProfileId/learning',
    ownerTask: 'Phase 45.7',
  },
  {
    id: 'training',
    labelKey: 'crm.customerProfile.navigation.training',
    labelFallback: 'Training',
    availabilityKey: null,
    availabilityFallback: null,
    deliveryState: 'delivered',
    route: '/$locale/crm/user-profiles/$userProfileId/training',
    ownerTask: 'Phase 45.8',
  },
  {
    id: 'documents',
    labelKey: 'crm.customerProfile.navigation.documents',
    labelFallback: 'Documents',
    availabilityKey: null,
    availabilityFallback: null,
    deliveryState: 'delivered',
    route: '/$locale/crm/user-profiles/$userProfileId/documents',
    ownerTask: 'Phase 45.5',
  },
  {
    id: 'sync',
    labelKey: 'crm.customerProfile.navigation.sync',
    labelFallback: 'Sync',
    availabilityKey: null,
    availabilityFallback: null,
    deliveryState: 'delivered',
    route: '/$locale/crm/user-profiles/$userProfileId/sync',
    ownerTask: 'Phase 45.4a',
  },
  {
    id: 'commercial',
    labelKey: 'crm.customerProfile.navigation.commercial',
    labelFallback: 'Commercial',
    availabilityKey: 'crm.customerProfile.navigation.notAvailableYet',
    availabilityFallback: 'Not available yet',
    deliveryState: 'undelivered',
    route: null,
    ownerTask: 'Phases 45.9 and 45.10',
  },
  {
    id: 'communications',
    labelKey: 'crm.customerProfile.navigation.communications',
    labelFallback: 'Communications',
    availabilityKey: 'crm.customerProfile.navigation.notAvailableYet',
    availabilityFallback: 'Not available yet',
    deliveryState: 'undelivered',
    route: null,
    ownerTask: 'Phase 45.12',
  },
  {
    id: 'activity',
    labelKey: 'crm.customerProfile.navigation.activity',
    labelFallback: 'Activity',
    availabilityKey: 'crm.customerProfile.navigation.notAvailableYet',
    availabilityFallback: 'Not available yet',
    deliveryState: 'undelivered',
    route: null,
    ownerTask: 'Phase 45.11',
  },
] as const;

export type CrmCustomerRecordArea = (typeof crmCustomerRecordAreas)[number];
export type DeliveredCrmCustomerRecordArea = Extract<
  CrmCustomerRecordArea,
  { deliveryState: 'delivered' }
>;
export type CrmCustomerRecordAreaId = CrmCustomerRecordArea['id'];

export function findCrmCustomerRecordArea(areaId: string): CrmCustomerRecordArea | undefined {
  return crmCustomerRecordAreas.find((area) => area.id === areaId);
}

export function firstAccessibleCrmCustomerRecordArea(
  allowedAreas: readonly CrmCustomerRecordDeliveredArea[]
): DeliveredCrmCustomerRecordArea | null {
  return (
    crmCustomerRecordAreas.find(
      (area): area is DeliveredCrmCustomerRecordArea =>
        area.deliveryState === 'delivered' && allowedAreas.includes(area.id)
    ) ?? null
  );
}
